import React from "react";
import PropTypes from "prop-types";

const getInitialState = (roomId, isOpen = false) => {
  // isOpen for storybook
  return { currentRoomId: roomId, panel_is_open: isOpen, url: "home", reset_chat: false, left_room_message: null };
};

export const routes = {
  room: "room",
  home: "home",
  list: "list",
  room_settings: "room/room_settings",
  member_list: "room/member_list",
};
// keep 'url' string in state and parse it.

const reducer = (state, action) => {
  if (action.type === "SELECT_ROOM") {
    return { ...state, currentRoomId: action.payload, url: routes.room, panel_is_open: true };
  }
  if (action.type === "ROOM_SETTINGS") {
    return { ...state, currentRoomId: action.payload, url: routes.room_settings };
  }
  if (action.type === "MEMBER_LIST") {
    return { ...state, currentRoomId: action.payload, url: routes.member_list };
  }
  if (action.type === "NAVIGATE_HOME") {
    return getInitialState();
  }
  if (action.type === "NAVIGATE_TO_LIST") {
    return { ...state, url: "list", currentRoomId: null, panel_is_open: true };
  }
  if (action.type === "HOME") {
    return { ...state, currentRoomId: null, url: "home", panel_is_open: true };
  }
  if (action.type === "OPEN_PANEL") {
    return { ...state, panel_is_open: true };
  }
  if (action.type === "RESET_CHAT") {
    return { ...state, currentRoomId: null, url: routes.home, reset_chat: action.payload };
  }
  if (action.type === "CLOSE_PANEL") {
    return { ...state, panel_is_open: false };
  }
  if (action.type === "UPDATE_LEFT_ROOM_MESSAGE") {
    return { ...state, left_room_message: action.payload };
  }

  throw new Error("the chat navigation action you dispatched is not defined");
};

const ChatNavigationContext = React.createContext();
const useChatNavigationContext = () => {
  const context = React.useContext(ChatNavigationContext);
  if (!context) {
    throw new Error("useChatNavigationContext must be used within Chat Navigation Provider(Context) ");
  }
  return context;
};

const ChatNavigationProvider = ({ children, roomId, isOpen }) => {
  const value = React.useReducer(reducer, getInitialState(roomId, isOpen));
  return (
    <ChatNavigationContext.Provider value={value}>
      {typeof children === "function" ? children(value) : children}
    </ChatNavigationContext.Provider>
  );
};

ChatNavigationProvider.propTypes = {
  roomId: PropTypes.number,
  children: PropTypes.any,
};

export { useChatNavigationContext, ChatNavigationProvider };
export default ChatNavigationContext;
